import * as React from 'react'
import {FC} from 'react'
import {Spin} from 'antd'
import LoadingOutlined from '@ant-design/icons/lib/icons/LoadingOutlined'
import './index.less'

const antIcon = <LoadingOutlined style={{fontSize: 48}} spin />

const Loading: FC = () => {
    return (
        <div className={'e-loading'}>
            <Spin size={'large'} indicator={antIcon} />
        </div>
    )
}

export default Loading
